import React from "react";
import { useLocation } from "react-router-dom";
import "./enrollform.css";

const EnrollForm = () => {
  const location = useLocation();
  const courseName = location.state?.courseName || "Program";

  return (
    <div className="enroll-form-container">
      <h2>{courseName}</h2>

      <div className="contact-info">
        <p>
          For any queries regarding <strong>{courseName}</strong>, please contact us:
        </p>
        <p>📱 Mobile: +91-8121956868</p>
        <p>
          📧 Email:{" "}
          <a href="https://mail.google.com/mail/?view=cm&fs=1&to=skill-upgrade@neelaverse.com"
             target="_blank" 
             rel="noopener noreferrer">
            skill-upgrade@neelaverse.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default EnrollForm;
